export enum TotLocale {
    ru = 'ru',
    en = 'en',
}

export type LocalizedMessages = Record<TotLocale, Record<string, string>>;
